import {
  getResponseById,
  GetResponseByIdRequestParams,
} from "@/requests/questionnaries/response-by-id.request";
import { useQuery } from "@tanstack/react-query";

/**
 * Build the query key for a question in a quiz
 */
export const buildResponseByIdQueryKey = (
  variables: GetResponseByIdRequestParams,
) => [
  "companies",
  variables.companyId,
  "quiz",
  variables.quizId,
  "responses",
  variables.responseId,
  "question",
];

/**
 * Get the details of a question by id
 */
export const useResponseById = (
  variables: GetResponseByIdRequestParams,
  isEnabled: boolean = true,
) => {
  const queryKey = buildResponseByIdQueryKey(variables);

  return useQuery({
    queryKey,
    queryFn: ({ signal }) => getResponseById(variables, signal),
    enabled: Object.values(variables).every(Boolean) && isEnabled,
  });
};
